import React, { useContext, useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { DarkModeContext } from "../../context/DarkModeContext";
import logo from "../../assets/img/logo.png";
import { getToken } from "../../utils/auth";


const ModalBancoAdmin = ({ show, onHide, banco, onSuccess }) => {
    const { darkMode } = useContext(DarkModeContext);
    const [nomBanco, setNomBanco] = useState("");
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        setNomBanco(banco?.nomBanco || "");
    }, [banco, show]);

    const mostrarMensaje = (title, text, icon) => {
        Swal.fire({
            title,
            text,
            icon,
            imageUrl: icon === "success" ? undefined : logo,
            imageWidth: 100,
            imageHeight: 30,
            imageAlt: "Logo",
            confirmButtonText: "Ok",
            allowOutsideClick: true,
            customClass: {
                container: darkMode ? "swal2-container--dark" : "swal2-container--light",
                confirmButton: "my-swal-button",
            },
        });
    };

    const guardar = async (e) => {
        e.preventDefault();

        const token = getToken();
        if (!token) {
            mostrarMensaje("Error", "Token no disponible.", "error");
            return;
        }

        if (!nomBanco.trim()) {
            mostrarMensaje("Error", "El nombre del banco es obligatorio.", "error");
            return;
        }

        setGuardando(true);
        try {
            const endpoint = banco?.codBanco ? process.env.REACT_APP_API_BANCO_EDITAR : process.env.REACT_APP_API_BANCO_CREAR;
            const response = await fetch(endpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    Token: token,
                    CodBanco: banco?.codBanco || 0,
                    NomBanco: nomBanco.trim(),
                }),
            });

            const text = await response.text();
            if (!response.ok) {
                throw new Error(text || "No se pudo guardar el banco.");
            }

            mostrarMensaje(
                "Exito",
                banco?.codBanco ? "Banco editado correctamente." : "Banco creado correctamente.",
                "success"
            );
            onSuccess?.();
            onHide?.();
        } catch (error) {
            mostrarMensaje("Error", error.message || "No se pudo guardar el banco.", "error");
        } finally {
            setGuardando(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered size="lg" aria-labelledby="modal-banco-admin">
            <Modal.Body className={darkMode ? "modal-content text-black" : "modal-content text-black"}>
                <section className="d-flex justify-content-between my-4">
                    <div className="ocultar-div"></div>
                    <div className="d-flex justify-content-center">
                        <h6 className="fs-18 lato-bold">{banco?.codBanco ? "Editar Banco" : "Nuevo Banco"}</h6>
                    </div>
                    <div>
                        <button className="border-0 btn-filtro-cruz" onClick={onHide}>
                            <FontAwesomeIcon className="fs-18" icon={faXmark} />
                        </button>
                    </div>
                </section>

                <form onSubmit={guardar}>
                    <div className="form-group col-12">
                        <label className="fs-14 mb-2 ms-1">Nombre del banco</label>
                        <input
                            type="text"
                            className="form-control input-cargar-nueva-busqueda"
                            placeholder="Ingrese el nombre del banco"
                            value={nomBanco}
                            maxLength={50}
                            onChange={(e) => setNomBanco(e.target.value)}
                        />
                    </div>

                    <div className="d-flex justify-content-between mt-5">
                        <button
                            type="button"
                            className="btn-cancel-modificaciones-nuevo-puesto border-0 lato-bold text-white"
                            onClick={onHide}
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="btn-guardar-modificaciones-nuevo-puesto border-0 lato-bold text-white"
                            disabled={guardando}
                        >
                            {guardando ? <Spinner animation="border" size="sm" /> : "Guardar"}
                        </button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default ModalBancoAdmin;
